<div *ngIf="parentForm" [formGroup]="parentForm" class="mb-3">
  <input [ngClass]="{'is-invalid': error}"
         (ngModelChange)="selectLink($event)"
         [(ngModel)]="link" [ngModelOptions]="{standalone: true}"
         class="form-control" (change)="selectLink($event)" id="actionDetail" type="text">
  <div *ngIf="error" class="invalid-feedback">
    <span *ngIf="error">{{'VALUE_REQUIRED' | translate}}</span>
  </div>
</div>
